export const arrowIcon = {
  data: `<svg viewBox="0 0 32 32">
    <title>arrow</title>
    <path
      stroke-linejoin="miter"
      stroke-linecap="round"
      stroke-miterlimit="4"
      d="M1 15h30"
    ></path>
    <path
      stroke-linejoin="miter"
      stroke-linecap="round"
      stroke-miterlimit="4"
      d="M11 5l-10 10"
    ></path>
    <path
      stroke-linejoin="miter"
      stroke-linecap="round"
      stroke-miterlimit="4"
      d="M11 25l-10-10"
    ></path>
  </svg>`,
  name: 'arrow',
};
